import request from '@/utils/request';
import { isMobile } from '@/utils/device';
// PC端-首页-顶部
// OW_PC_1000
// PC端-SaaS电子合同-顶部
// OW_PC_1001
// PC端-开发平台-顶部
// OW_PC_1002
// PC端-定价-顶部
// OW_PC_1003
// PC端-文件验签-顶部
// OW_PC_1004
// PC端-生态合作-详情页-顶部
// OW_PC_1005
// PC端-生态合作-信息收集页-顶部
// OW_PC_1006
// PC端-关于我们-公司介绍页-顶部
// OW_PC_1007
// PC端-关于我们-笔迹大数据研究院页-顶部
// OW_PC_1008
// PC端-首页-生态合作-中部
// OW_PC_1009
// PC端-新闻中心-顶部
// OW_PC_1010
// 移动端-首页-顶部
// OW_APP_1000
// 移动端-SaaS电子合同-顶部
// OW_APP_1001
// 移动端-开发平台-顶部
// OW_APP_1002
// 移动端-定价-顶部
// OW_APP_1003
// 移动端-文件验签-顶部
// OW_APP_1004
// 移动端-生态合作-详情页-顶部
// OW_APP_1005
// 移动端-生态合作-信息收集页-顶部
// OW_APP_1006
// 移动端-关于我们-公司介绍页-顶部
// OW_APP_1007
// 移动端-关于我们-笔迹大数据研究院页-顶部
// OW_APP_1008
// 移动端-首页-生态合作-中部
// OW_APP_1009
// 移动端-新闻中心-顶部
// OW_APP_1010
/**
 * 获取banner图
 * @parems num: enum
 * @returns
 */
export const getAdInfo = (num) => {
  const code = `OW_${isMobile() ? 'APP' : 'PC'}_${num}`;
  return request({
    url: `/openApi/ad/query`,
    method: 'post',
    data: { adCode: code },
  });
};

/**
 * 获取验证码
 * @params {}
 * @params phone: string
 * @returns
 */
export const getSmsCode = (obj) => {
  return request({
    url: '/openApi/sms/sendFreeTrialSmsCode',
    method: 'post',
    data: { phone: obj.phone },
  });
};

/**
 * 提交用户信息
 * @params obj
 * @params customerName:string 用户名
 * @params companyName:string 公司名
 * @params phone:string  电话号码
 * @params smsCode:string  验证码
 * @params type: number {0: 免费试用， 1: 生态合作}
 * @params trade?: string 行业
 * @params companyScale?: string 公司规模
 * @params city?： string 城市
 * @arams job?： string 职位
 * @params source： number {0: 官网}
 */
export const sendCustomInfo = (params, type = 0) => {
  return request({
    url: '/openApi/businessOpportunity/add',
    method: 'post',
    data: { ...params, source: 0, type },
  });
};

/**
 * 文件验签
 * @params {}
 * @params file?: file 验签的文件
 * @params sm3?: string 文件的sm3值(file与sm3，必传其中一个值)
 * @params current?: number 当前页
 * @params size?: number 每页数量
 */
export const checkSignFile = (params) => {
  return request({
    url: '/openApi/file/verifySign',
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    data: params,
  });
};

/**
 * 新闻列表查询
 * @params {}
 * @params type?: number 1: 公司动态； 2：政策解读； 3： 知识科普； 不传type 查询所有
 * @params current: number 当前页
 * @params size 每页条数
 */
export const getNewsList = (params) => {
  return request({
    url: '/openApi/newsInformation/pageList',
    method: 'post',
    data: params,
  });
};

/**
 * 新闻预览页
 * @params id: number
 */
export const getDetailById = (id) => {
  return request({
    url: `/openApi/newsInformation/detail/${id}`,
    method: 'post',
  });
};

/**
 * 获取小程序链接
 */
export const getUrllink = () => {
  return request({
    url: '/openApi/wx/getUrllink',
    method: 'get',
  });
};
